import React from "react";
import { useTranslation } from "react-i18next";

const TYPE_FUNCTIONALITY_CLOCKINS = 1;

export function isClockinsLicenseType(licenseTypes, licenseTypeUID) {
    const licenseType = licenseTypes.find(type => type.uid === licenseTypeUID);
    return licenseType?.typeFunctionality === TYPE_FUNCTIONALITY_CLOCKINS;
}

export function VirtualClockinCheckbox({ checked, onChange }) {
    const { t } = useTranslation();

    return (
        <div className="form-check mt-3">
            <input
                className="form-check-input"
                type="checkbox"
                id="create-virtual-clockin"
                checked={checked}
                onChange={event => onChange(event.target.checked)}
            />
            <label className="form-check-label" htmlFor="create-virtual-clockin">
                {t("mod_budgets_create_virtual_clockin")}
            </label>
        </div>
    );
}
